module.exports = __webpack_public_path__ + "static/media/background-auto-submission@2x.f9b82c37.jpg";